var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"md-layout"},[_c('chat-card',_vm._b({attrs:{"sync":_vm.entity}},'chat-card',{ channelSid: _vm.entity.twilioChannelSid, clientId: _vm.entity.userId, clientName: _vm.entity.userName },false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }